import { call, put } from 'redux-saga/effects';
import { apiGeneral, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { DeleteDocumentActions } from 'store/ducks/documents';

export function* deleteDocumentRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/document/${id}`
    );

    const { data } = responseBody;
    yield put(DeleteDocumentActions.success(data));
    notify('success', 'Documento deletado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(DeleteDocumentActions.failure(errorMessage));
  }
}
